const normalizeStatus = (status) => {
  if (!status) return "";
  const s = String(status).trim().toLowerCase();
  if (s === "canceled") return "cancelled";
  return s;
};

export const getTicketStatusLabel = (t, status) => {
  const s = normalizeStatus(status);
  if (!s) return "—";
  return t(`tickets.status.${s}`, { defaultValue: s });
};

